/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 운영관리 - 기기등록 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
// utils
import clog from "../../../utils/logUtils";
//component
import DeviceList from "./DeviceList";
import DeviceInsert from "./DeviceInsert";
import DeviceBatch from "./DeviceBatch";
import DeviceListUpdate from "./DeviceListUpdate";
import NoDeviceView from "./NoDeviceView";
/**
 * @brief EHP 운영관리 -기기등록 관리 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
function AdminDevice(props) {
    //const [isMobile, setIsMobile] = useState(false);
    //const [adminType, setAdminType] = useState("ZONE"); // ZONE, SUBZONE, ROOM
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const curTree = props.curTree;
    const setCurTree = props.setCurTree;
    const workMode = props.workMode;
    const setAdminType = props.setAdminType;
    const setNodata = props.setNodata;
    const [restart, setRestart] = useState(false);
    //
    const [listWork, setListWork] = useState(false);
    const [listItem, setListItem] = useState(null);
    const [reWork, setReWork] = useState(null);
    /*
      const [curTree, setCurTree] = useState({
        company:{companyId:"", companyName:""},
        zone:{zoneId:"", zoneName:""},
        subZone:{subZoneId:"", subZoneName:""},
        room:{roomId:"", roomName:""},
        spg:{spgId:-1, spgName:""}
      });
    
    
      function handleCurTree(adminType, treeInfo) {
        clog("IN SITETREE : handleCurTree : " + adminType);
        setParentAdminType(adminType);
        setCurTree(treeInfo);
      }
    */
    useEffect(() => {
        setReWork(curTree);
    }, [curTree]);
    clog("IN DEVICE : INIT :" + JSON.stringify(curTree) + "  : " + adminType + " : " + workMode);
    return (React.createElement(React.Fragment, null,
        (curTree.room.roomId.length <= 0) ?
            React.createElement(NoDeviceView, { setIsMobile: props.setIsMobile, curTree: curTree, setPopWin: props.setPopWin })
            :
                (workMode === "LIST") && (!listWork) && React.createElement(DeviceList, { curTree: curTree, isMobile: props.isMobile, workMode: props.workMode, setIsMobile: props.setIsMobile, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin, setListWork: setListWork, listItem: listItem, setListItem: setListItem, restart: restart, setRestart: setRestart, reWork: reWork, setReWork: setReWork, setNodata: setNodata }),
        (workMode === "LIST") && (listWork) && React.createElement(DeviceListUpdate, { curTree: curTree, isMobile: props.isMobile, workMode: props.workMode, setIsMobile: props.setIsMobile, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin, setListWork: setListWork, listItem: listItem, setListItem: setListItem, reWork: reWork, setReWork: setReWork, restart: restart, setRestart: setRestart }),
        (workMode === "CREATE") && React.createElement(DeviceInsert, { curTree: curTree, isMobile: props.isMobile, workMode: props.workMode, setIsMobile: props.setIsMobile, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin, restart: restart, setRestart: setRestart }),
        (workMode === "BATCH") && React.createElement(DeviceBatch, { curTree: curTree, isMobile: props.isMobile, workMode: props.workMode, setIsMobile: props.setIsMobile, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin, restart: restart, setRestart: setRestart })));
}
;
export default AdminDevice;
